import { render, staticRenderFns } from "./Efo.vue?vue&type=template&id=24c38aa9&scoped=true&lang=pug&"
import script from "./Efo.vue?vue&type=script&lang=js&"
export * from "./Efo.vue?vue&type=script&lang=js&"
import style0 from "./Efo.vue?vue&type=style&index=0&id=24c38aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c38aa9",
  null
  
)

export default component.exports